import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import {
	useGetAllDriversQuery,
	useGetDriversByDeviceQuery,
	useGetDriversByUserQuery,
} from "../../../Redux/service/DriversTraccar/DriversTraccar";
import { popupcontext } from "../../../context/Popupscontext";
import { uniqueId } from "lodash";

export default function DriversMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);

	const [isOpen, setIsOpen] = useState(false);
	const [selectedDrivers, setSelectedDrivers] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AdminDrivers, refetch: AdminDriversRefetch } =
		useGetAllDriversQuery(undefined, {
			refetchOnMountOrArgChange: true,
		});
	let { data: DriverVehicles, refetch: DriverVehiclesRefetch } =
		useGetDriversByDeviceQuery(vehicleId, {
			skip: !vehicleId,
			refetchOnMountOrArgChange: true,
		});
	let { data: UsersDrivers, refetch: UsersDriversRefetch } =
		useGetDriversByUserQuery(userId, {
			skip: !userId,
			refetchOnMountOrArgChange: true,
		});

	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AdminDrivers && UsersDrivers) {
			const merged = [...AdminDrivers, ...UsersDrivers];
			const unique = merged.filter(
				(item, index, self) =>
					index === self.findIndex((t) => t.id === item.id),
			);
			setMergedData(unique);
		}
	}, [AdminDrivers, UsersDrivers]);
	useEffect(() => {
		if (
			isFirstMount.current ||
			AdminDriversRefetch ||
			UsersDriversRefetch ||
			DriverVehiclesRefetch
		) {
			if (mergedData?.length === 0) {
				setGroups(
					(AdminDrivers || UsersDrivers || DriverVehicles)?.map((i) => ({
						value: i.id,
						label: i.type,
					})),
				);
			} else {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.name,
					})),
				);
			}
		}
		isFirstMount.current = false;
	}, [
		AdminDriversRefetch,
		DriverVehiclesRefetch,
		mergedData,
		UsersDriversRefetch,
		AdminDrivers,
		UsersDrivers,
		DriverVehicles,
	]);
	useEffect(() => {
		if (type === "users") {
			if (UsersDrivers) {
				// Only the drivers actually linked to this user should appear selected;
				// mergedData also contains all available drivers (for the dropdown options).
				setSelectedDrivers(UsersDrivers?.map((i) => i.id));
			}
		} else if (type === "vehicles") {
			if (DriverVehicles) {
				setSelectedDrivers(DriverVehicles?.map((i) => i.id));
			}
		}
	}, [UsersDrivers, DriverVehicles, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "vehicles" && vehicleId) {
				DriverVehiclesRefetch();
			} else if (type === "users") {
				UsersDriversRefetch();
			}
		}
	}, [DriverVehiclesRefetch, isLinking, vehicleId, type, UsersDriversRefetch]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedDrivers((prev) => [...prev, value]);
						handleLink(value, "driver", "Driver");
					}}
					onDeselect={(value) => {
						setSelectedDrivers((prev) => prev.filter((v) => v !== value));

						handleUnLink(value, "driver", "Driver");
					}}
					value={selectedDrivers || ""}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
